import React from 'react';
import IcPhone from 'assets/images/backoffice/capital/ic-phone.svg';
import Button from '../Button';
import styles from './InfoCard.css';
import InfoCard from './InfoCard';

function ContactCapital(props) {
  const { title } = props;
  return (
    <InfoCard
      title={title || 'Ada pertanyaan? Hubungi Moka Capital'}
      icon={<img src={IcPhone} className={styles.phone} />}
    >
      <div className={styles['contact-capital-wrapper']}>
        <div className={styles.row}>
          <Button
            full
            icon="whatsapp"
            title="Hubungi via WhatsApp"
            btnType="outline"
            href="https://www.mokapos.com/capital/clkn/https/web.whatsapp.com/send?phone=6281299899970&text=Halo%2C%20saya%20mau%20tanya%20tentang%20Moka%20Capital"
            target="_blank"
          />
        </div>
        <div className={styles.row}>
          <Button
            full
            icon="email"
            title="Hubungi via Email"
            btnType="outline"
            href="mailto:capital@mokapos.com"
            target="_blank"
          />
        </div>
      </div>
    </InfoCard>
  );
}

export default ContactCapital;
